import React, { useEffect, useState } from 'react';
interface PriceDisplayProps {
  amount: number;
  className?: string;
  showCurrencyCode?: boolean;
}
export function PriceDisplay({
  amount,
  className = '',
  showCurrencyCode = false
}: PriceDisplayProps) {
  const [currency, setCurrency] = useState({
    symbol: '$',
    code: 'USD'
  });
  useEffect(() => {
    const locale = navigator.language || 'en-US';
    // Simple mapping logic as requested
    if (locale.startsWith('es')) {
      setCurrency({
        symbol: '$',
        code: 'USD'
      });
    } else if (locale === 'en-GB') {
      setCurrency({
        symbol: '£',
        code: 'GBP'
      });
    } else if (locale === 'en-AU') {
      setCurrency({
        symbol: 'A$',
        code: 'AUD'
      });
    } else if (['de', 'fr', 'it', 'pt', 'nl'].some(l => locale.startsWith(l))) {
      setCurrency({
        symbol: '€',
        code: 'EUR'
      });
    } else {
      setCurrency({
        symbol: '$',
        code: 'USD'
      });
    }
  }, []);
  return <span className={className} data-id="element-111">
      {currency.symbol}
      {amount.toFixed(2)}
      {showCurrencyCode ? ` ${currency.code}` : ''}
    </span>;
}